import React, { useState } from "react";
import { InputForm } from "../../_helpers/components/Forms/InputLabel";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ResetPassword } from "../../_api/Admin";
import { Button } from "../../_helpers/components/Button";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const { token } = useParams();

    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const subdomain = window.location.hostname.split(".")[0];
    const isEpvSubdomain = subdomain === "epv";

    const validatePassword = (pwd) => {
        const minLength = isEpvSubdomain ? 12 : 6;
        const lengthCheck = pwd.length >= minLength;

        if (!isEpvSubdomain) {
            return {
                lengthCheck,
                isValid: lengthCheck,
            };
        }

        const specialCharCheck = /[!@#$%^&*(),.?":{}|<>]/.test(pwd);
        const uppercaseCheck = /[A-Z]/.test(pwd);
        const lowercaseCheck = /[a-z]/.test(pwd);
        const digitCheck = /[0-9]/.test(pwd);

        return {
            lengthCheck,
            specialCharCheck,
            uppercaseCheck,
            lowercaseCheck,
            digitCheck,
            isValid:
                lengthCheck &&
                specialCharCheck &&
                uppercaseCheck &&
                lowercaseCheck &&
                digitCheck,
        };
    };

    const validation = validatePassword(password);

    const resetPasswordSubmit = (e) => {
        e.preventDefault();

        if (password !== password2) {
            toast.error("Attention : les deux mots de passe sont différents.");
            return;
        }

        if (!validation.isValid) {
            setError("Le mot de passe ne remplit pas tous les critères.");
            return;
        }

        setError(null);

        setIsSubmitting(true);
        ResetPassword({ password, password2, token })
            .then((resp) => {
                toast.success("Le mot de passe a bien été modifié");
                setPassword("");
                setPassword2("");
                setTimeout(() => {
                    navigate("/");
                }, 1000);
            })
            .catch((data) => {
                const { message } = data.response.data;
                toast.error(message);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <div className="flex lg:w-1/2 items-center justify-center min-h-full bg-gray-50 px-4">
            <form
                onSubmit={resetPasswordSubmit}
                className="bg-white p-6 rounded-lg shadow-md w-full max-w-md"
            >
                <h1 className="text-2xl font-semibold mb-4 text-center">
                    Écrivez votre nouveau mot de passe
                </h1>
                <InputForm
                    set={setPassword}
                    name="Nouveau mot de passe :"
                    type="password"
                    value={password}
                    placeholder="Mot de passe ..."
                    required={true}
                />
                <InputForm
                    set={setPassword2}
                    name="Confirmation du mot de passe :"
                    type="password"
                    value={password2}
                    placeholder="Confirmation mot de passe..."
                    required={true}
                />

                {/* Critères de mot de passe */}
                <div className="text-xs text-left mt-2 space-y-1 mb-2">
                    <p
                        className={
                            validation.lengthCheck
                                ? "text-green-600 mb-0"
                                : "text-red-600 mb-0"
                        }
                    >
                        • Au moins {isEpvSubdomain ? 12 : 6} caractères
                    </p>
                    {isEpvSubdomain && (
                        <>
                            <p
                                className={
                                    validation.specialCharCheck
                                        ? "text-green-600"
                                        : "text-red-600"
                                }
                            >
                                • Un caractère spécial (ex : !@#$%)
                            </p>
                            <p
                                className={
                                    validation.uppercaseCheck
                                        ? "text-green-600"
                                        : "text-red-600"
                                }
                            >
                                • Au moins une majuscule
                            </p>
                            <p
                                className={
                                    validation.lowercaseCheck
                                        ? "text-green-600"
                                        : "text-red-600"
                                }
                            >
                                • Au moins une minuscule
                            </p>
                            <p
                                className={
                                    validation.digitCheck
                                        ? "text-green-600"
                                        : "text-red-600"
                                }
                            >
                                • Au moins un chiffre
                            </p>
                        </>
                    )}
                </div>

                {error && (
                    <p className="text-red-500 text-sm italic mb-2 text-left">
                        {error}
                    </p>
                )}

                <Button
                    action={resetPasswordSubmit}
                    name="Réinitialiser"
                    loading={isSubmitting}
                    disabled={!validation.isValid || password !== password2}
                />
            </form>
        </div>
    );
};

export default ForgotPassword;
